<div
    *ngIf="this.uploadResult && this.getResultKeys().length > 0"
    class="result-box"
    fxLayout="column"
    fxLayoutAlign="start stretch"
    style="width: 100%">
    <p class="view-title">{{ resultsKey | translate }}</p>
    <div *ngFor="let category of this.getResultKeys()">
        <div *ngIf="uploadResult[category].categoryFail; else catPass">
            <div class="cat-fail" fxLayout="column" fxLayoutAlign="start stretch">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <span [ngStyle]="this.getCategoryStyle(category)">{{ this.getSanitizedName(category) }}</span>
                </div>
                <div class="cat-fail-results">
                    <ul>
                        <li *ngFor="let err of uploadResult[category].data; let i = index">
                            {{ uploadResult[category].data[i] }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <ng-template #catPass>
            <div class="cat-pass" fxLayout="column" fxLayoutAlign="start stretch">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <div fxFlex="20">
                        <span [ngStyle]="getCategoryStyle(category)">{{ getSanitizedName(category) }}</span>
                    </div>
                    <div fxFlex="20">
                        {{ rowsKey | translate }}
                        {{ uploadResult[category].report.metadata.total }}
                    </div>
                    <div fxFlex="15">
                        <fa-icon [icon]="faPass" style="color: green"></fa-icon>&nbsp;&nbsp;
                        {{ uploadResult[category].report.metadata.success }}
                    </div>
                    <div fxFlex="15">
                        <fa-icon [icon]="faFail" style="color: red"></fa-icon>&nbsp;&nbsp;
                        {{ uploadResult[category].report.metadata.failure }}
                    </div>
                </div>
                <div
                    *ngIf="uploadResult[category].report.metadata.failure > 0 || uploadResult[category].report.metadata.success > 0"
                    class="cat-fail-results">
                    <ul>
                        <li
                            *ngFor="let err of getFailureResultsForCategory(category); let i = index"
                            id="{{ 'import-fail-category-' + category + '-' + i }}">
                            <span class="row-identifier"
                                >{{ rowKey | translate }} [{{ err.identifier.property }}
                                =
                                {{ err.identifier.value }}]</span
                            >
                            <span class="row-error">{{ err.dataAsText }}</span>
                        </li>
                    </ul>
                </div>
                <!-- After Import Process Results -->
                <div class="after-import-process-results-box" *ngIf="uploadResult[category].report.afterImportProcessorResults.length > 0">
                    <span>{{ 'view.afterImportProcessResults' | translate }}</span>
                    <ul>
                        <li *ngFor="let processResult of uploadResult[category].report.afterImportProcessorResults" style="margin-top: 6px">
                            <span
                                [ngClass]="{
                                    'after-import-processor-type-label': true,
                                    'success-highlighted-label': processResult.success,
                                    'failure-highlighted-label': !processResult.success
                                }"
                                >{{ getSanitizedName(processResult.processorType) }}</span
                            >
                            <span class="after-import-processor-type-message">{{ getAfterImportProcessResultMessage(processResult) }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </ng-template>
    </div>
</div>
